import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { ReactComponent as ChatIcon } from "../../assets/chat.svg";
import { ReactComponent as CreditIcon } from "../../assets/credit.svg";
import { ReactComponent as InboxIcon } from "../../assets/inbox.svg";

export const HowItWorksSection: React.FC = () => {
  const { t } = useTranslations();

  return (
    <CRMInfoSection
      title={t({
        id: "client-support-page.how-it-works",
        defaultMessage: "How it works:",
      })}
      items={[
        {
          icon: <ChatIcon className="h-5 w-5 shrink-0" />,
          title: t({
            id: "client-support-page.how-it-works-ai-agent-title",
            defaultMessage: "AI Agent",
          }),
          description: t({
            id: "client-support-page.how-it-works-ai-agent-description",
            defaultMessage:
              "AI Agent will use available knowledge, instructions and automations to respond to your Customers in Gmail",
          }),
        },
        {
          icon: <CreditIcon className="h-5 w-5 shrink-0" />,
          title: t({
            id: "client-support-page.how-it-works-message-credits-title",
            defaultMessage: "Message Credits usage",
          }),
          description: t({
            id: "client-support-page.how-it-works-message-credits-description",
            defaultMessage:
              "AI Agent will use 1 Message Credit per each generated reply",
          }),
        },
        {
          icon: <InboxIcon className="h-5 w-5 shrink-0" />,
          title: t({
            id: "client-support-page.how-it-works-inbox-title",
            defaultMessage: "See conversations in Inbox",
          }),
          description: t({
            id: "client-support-page.how-it-works-inbox-description",
            defaultMessage:
              "All conversations made in Gmail Channel will be stored in the Inbox Module",
          }),
        },
      ]}
    />
  );
};
